import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { AlertCircle } from "lucide-react";

import { signin } from "../../services/oprations/authAPI";

const VerifyEmail = () => {
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { signinData } = useSelector((state) => state.auth);

  const handleVerify = (e) => {
    e.preventDefault();
    setOtpError("");

    if (!otp) {
      setOtpError("Please enter the OTP");
      return;
    }

    const { email, password } = signinData;

    if (!email || !password) {
      toast.error("Invalid session. Please login again.");
      navigate("/login");
      return;
    }

    dispatch(signin(email, password, otp, navigate));
  };

  return (
    <div className="bg-gradient-to-br from-indigo-500 via-purple-500 to-purple-600 min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      {/* Floating Background Shapes */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-10 w-20 h-20 bg-white/10 rounded-full animate-pulse"></div>
        <div
          className="absolute top-60 right-10 w-32 h-32 bg-white/10 rounded-full animate-bounce"
          style={{ animationDelay: "2s", animationDuration: "6s" }}
        ></div>
        <div
          className="absolute bottom-20 left-20 w-16 h-16 bg-white/10 rounded-full animate-ping"
          style={{ animationDelay: "4s", animationDuration: "4s" }}
        ></div>
      </div>

      {/* Main Container */}
      <div className="w-full max-w-md bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/30 overflow-hidden relative">
        {/* Header Section */}
        <div className="bg-gradient-to-br from-indigo-500 to-purple-600 p-10 text-center text-white relative">
          <div className="absolute -bottom-5 left-0 right-0 h-10 bg-gradient-to-br from-indigo-500 to-purple-600 transform scale-x-125 rounded-b-[50%]"></div>

          <div className="relative z-10">
            <h1 className="text-2xl font-bold mb-2">Verify Your Email</h1>
            <p className="text-white/90 text-base">Enter the OTP sent to your registered email</p>
          </div>
        </div>

        {/* Form Section */}
        <div className="p-8 pt-12">
          <form onSubmit={handleVerify} className="space-y-6">
            {/* OTP Field */}
            <div className="space-y-2">
              <label className="block text-sm font-semibold text-gray-700">OTP</label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP"
                className={`w-full px-4 py-3 border-2 ${
                  otpError ? "border-red-300 bg-red-50" : "border-indigo-200 bg-white/90"
                } rounded-xl transition-all duration-300 focus:outline-none focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 transform focus:-translate-y-0.5`}
                required
              />
              {otpError && (
                <div className="flex items-center gap-2 text-sm text-red-500 animate-pulse">
                  <AlertCircle size={14} />
                  <span>{otpError}</span>
                </div>
              )}
            </div>

            {/* Verify Button */}
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white py-4 px-6 rounded-xl font-semibold text-base shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 disabled:opacity-70 disabled:transform-none disabled:cursor-not-allowed flex items-center justify-center gap-3 relative overflow-hidden group"
            >
              <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/30 to-transparent transform skew-x-12"></div>
              Verify OTP
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
